import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-grid">
                <div className="footer-brand">
                    <h2>THE PILLAR</h2>
                    <p>
                        High-performance digital architecture for modern business. 
                        Building structural integrity into every pixel.
                    </p>
                </div>

                <div className="footer-links">
                    <h4>Navigation</h4>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/about">About Us</Link></li>
                    </ul>
                </div>
            </div> {/* This closes the footer-grid */}

            <div className="footer-bottom">
                <p>&copy; 2026 GlowUp Digital | The Pillar Corporate Demo.</p>
                <p>Designed for Excellence.</p>
            </div>
        </footer>
    );
};

export default Footer;